!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react"), require("react-dom"), require("prop-types"), require("cytoscape")) : "function" == typeof define && define.amd ? define(["react", "react-dom", "prop-types", "cytoscape"], t) : "object" == typeof exports ? exports.ReactCytoscape = t(require("react"), require("react-dom"), require("prop-types"), require("cytoscape")) : e.ReactCytoscape = t(e.React, e.ReactDOM, e.PropTypes, e.cytoscape);
}(window, function (e, t, n, o) {
  return function (e) {
    var t = {};

    function n(o) {
      if (t[o]) return t[o].exports;
      var r = t[o] = {
        i: o,
        l: !1,
        exports: {}
      };
      return e[o].call(r.exports, r, r.exports, n), r.l = !0, r.exports;
    }

    return n.m = e, n.c = t, n.d = function (e, t, o) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: o
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var o = Object.create(null);
      if (n.r(o), Object.defineProperty(o, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var r in e) {
        n.d(o, r, function (t) {
          return e[t];
        }.bind(null, r));
      }
      return o;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 2);
  }([function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    },
        r = o({}),
        u = function u(e, t) {
      return null == e || null == t;
    };

    t.hashDiff = function (e, t) {
      return u(e, t) || e.hash() !== t.hash();
    }, t.shallowObjDiff = function (e, t) {
      if (u(e, t) && (null != e || null != t)) return !0;
      if (e === t) return !1;
      if ((void 0 === e ? "undefined" : o(e)) !== r || (void 0 === t ? "undefined" : o(t)) !== r) return e !== t;

      var n = Object.keys(e),
          i = Object.keys(t),
          l = function l(n) {
        return e[n] !== t[n];
      };

      return n.length !== i.length || !(!n.some(l) && !i.some(l));
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    t.get = function (e, t) {
      return null != e ? e[t] : null;
    }, t.toJson = function (e) {
      return e;
    }, t.forEach = function (e, t) {
      return e.forEach(t);
    };
  }, function (e, t, n) {
    "use strict";

    e.exports = n(3).default;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var o = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }

      return function (t, n, o) {
        return n && e(t.prototype, n), o && e(t, o), t;
      };
    }(),
        r = s(n(4)),
        u = s(n(5)),
        i = n(6),
        l = n(8),
        a = s(n(9)),
        c = n(10);

    function s(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    var f = function (e) {
      function t(e) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        var n = function (e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != typeof t && "function" != typeof t ? e : t;
        }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));

        return n.displayName = "CytoscapeComponent", n;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(t, r.default.Component), o(t, null, [{
        key: "normalizeElements",
        value: function value(e) {
          if (null != e.length) return e;
          var t = e.nodes,
              n = e.edges;
          return null == t && (t = []), null == n && (n = []), t.concat(n);
        }
      }, {
        key: "propTypes",
        get: function get() {
          return i.types;
        }
      }, {
        key: "defaultProps",
        get: function get() {
          return l.defaults;
        }
      }]), o(t, [{
        key: "componentDidMount",
        value: function value() {
          var e = u.default.findDOMNode(this),
              t = this.props,
              n = t.global,
              o = t.headless,
              r = t.styleEnabled,
              i = t.hideEdgesOnViewport,
              l = t.textureOnViewport,
              c = t.motionBlur,
              s = t.motionBlurOpacity,
              f = t.wheelSensitivity,
              d = t.pixelRatio,
              p = this._cy = new a.default({
            container: e,
            headless: o,
            styleEnabled: r,
            hideEdgesOnViewport: i,
            textureOnViewport: l,
            motionBlur: c,
            motionBlurOpacity: s,
            wheelSensitivity: f,
            pixelRatio: d
          });
          n && (window[n] = p), this.updateCytoscape(null, this.props);
        }
      }, {
        key: "updateCytoscape",
        value: function value(e, t) {
          var n = this._cy,
              o = t.diff,
              r = t.toJson,
              u = t.get,
              i = t.forEach;
          (0, c.patch)(n, e, t, o, r, u, i), null != t.cy && t.cy(n);
        }
      }, {
        key: "componentDidUpdate",
        value: function value(e) {
          this.updateCytoscape(e, this.props);
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          this._cy.destroy();
        }
      }, {
        key: "render",
        value: function value() {
          var e = this.props,
              t = e.id,
              n = e.className,
              o = e.style;
          return r.default.createElement("div", {
            id: t,
            className: n,
            style: o
          });
        }
      }]), t;
    }();

    t.default = f;
  }, function (t, n) {
    t.exports = e;
  }, function (e, n) {
    e.exports = t;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.types = void 0;

    var o = function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }(n(7));

    var r = o.default.string,
        u = o.default.array,
        i = o.default.object,
        l = o.default.number,
        a = o.default.bool,
        c = o.default.oneOfType,
        s = o.default.any,
        f = o.default.func;
    t.types = {
      id: r,
      className: r,
      style: c([r, i]),
      elements: c([u, s]),
      stylesheet: c([u, s]),
      layout: c([i, s]),
      pan: c([i, s]),
      zoom: l,
      panningEnabled: a,
      userPanningEnabled: a,
      minZoom: l,
      maxZoom: l,
      zoomingEnabled: a,
      userZoomingEnabled: a,
      boxSelectionEnabled: a,
      autoungrabify: a,
      autolock: a,
      autounselectify: a,
      get: f,
      toJson: f,
      diff: f,
      forEach: f,
      cy: f,
      headless: a,
      styleEnabled: a,
      hideEdgesOnViewport: a,
      textureOnViewport: a,
      motionBlur: a,
      motionBlurOpacity: l,
      wheelSensitivity: l,
      pixelRatio: c([r, i])
    };
  }, function (e, t) {
    e.exports = n;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.defaults = t.pan = t.zoom = t.stylesheet = t.elements = t.identity = void 0;
    var o = n(0),
        r = n(1),
        u = (t.identity = function (e) {
      return e;
    }, t.elements = [{
      data: {
        id: "a",
        label: "Example node A"
      }
    }, {
      data: {
        id: "b",
        label: "Example node B"
      }
    }, {
      data: {
        id: "e",
        source: "a",
        target: "b"
      }
    }]),
        i = t.stylesheet = [{
      selector: "node",
      style: {
        label: "data(label)"
      }
    }],
        l = t.zoom = 1,
        a = t.pan = {
      x: 0,
      y: 0
    };
    t.defaults = {
      diff: o.shallowObjDiff,
      get: r.get,
      toJson: r.toJson,
      forEach: r.forEach,
      elements: u,
      stylesheet: i,
      zoom: l,
      pan: a
    };
  }, function (e, t) {
    e.exports = o;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.patch = void 0;

    var o = n(1),
        r = n(0),
        u = function u(e, t, n, r) {
      return n((0, o.get)(e, r), (0, o.get)(t, r));
    },
        i = (t.patch = function (e, t, n, s, f, d, p) {
      e.batch(function () {
        (s === r.shallowObjDiff || u(t, n, s, "elements")) && c(e, (0, o.get)(t, "elements"), (0, o.get)(n, "elements"), f, d, p, s), u(t, n, s, "stylesheet") && a(e, (0, o.get)(t, "stylesheet"), (0, o.get)(n, "stylesheet"), f), ["zoom", "minZoom", "maxZoom", "zoomingEnabled", "userZoomingEnabled", "pan", "panningEnabled", "userPanningEnabled", "boxSelectionEnabled", "autoungrabify", "autolock", "autounselectify"].forEach(function (r) {
          u(t, n, s, r) && i(e, r, (0, o.get)(t, r), (0, o.get)(n, r), f);
        });
      }), u(t, n, s, "layout") && l(e, (0, o.get)(t, "layout"), (0, o.get)(n, "layout"), f);
    }, function (e, t, n, o, r) {
      e[t](r(o));
    }),
        l = function l(e, t, n, o) {
      var r = o(n);
      null != r && e.layout(r).run();
    },
        a = function a(e, t, n, o) {
      var r = e.style();
      null != r && r.fromJson(o(n)).update();
    },
        c = function c(e, t, n, o, r, u, i) {
      var l = [],
          a = e.collection(),
          c = [],
          f = {},
          d = {},
          p = function p(e) {
        return r(r(e, "data"), "id");
      };

      u(n, function (e) {
        var t = p(e);
        d[t] = e;
      }), null != t && u(t, function (t) {
        var n = p(t);
        f[n] = t, function (e) {
          return null != d[e];
        }(n) || a.merge(e.getElementById(n));
      }), u(n, function (e) {
        var t = p(e),
            n = function (e) {
          return f[e];
        }(t);

        !function (e) {
          return null != f[e];
        }(t) ? l.push(o(e)) : c.push({
          ele1: n,
          ele2: e
        });
      }), a.length > 0 && e.remove(a), l.length > 0 && e.add(l), c.forEach(function (t) {
        var n = t.ele1,
            u = t.ele2;
        return s(e, n, u, o, r, i);
      });
    },
        s = function s(e, t, n, o, r, u) {
      var i = r(r(n, "data"), "id"),
          l = e.getElementById(i),
          a = {};
      ["data", "position", "selected", "selectable", "locked", "grabbable", "classes"].forEach(function (e) {
        var i = r(n, e);
        u(i, r(t, e)) && (a[e] = o(i));
      });
      var c = r(n, "scratch");
      u(c, r(t, "scratch")) && l.scratch(o(c)), Object.keys(a).length > 0 && l.json(a);
    };
  }]);
});